export default __webpack_public_path__ + "static/media/ArrviedPatient.541f4666.svg";